import { useEffect, useState } from 'react';

function Counter({
  initialNumber = 0,
  step = 1,
  minimum = 0,
  maximum = 1000,
  onChange = () => {},
  disabled = false,
}) {
  const [number, setNumber] = useState(0);
  useEffect(() => {
    setNumber(initialNumber);
  }, [initialNumber]);

  function decrease() {
    const newNumber = number - step;
    if (newNumber >= minimum && !disabled) {
      setNumber(newNumber);
      onChange(newNumber);
    }
  }

  function increase() {
    const newNumber = number + step;
    if (newNumber <= maximum && !disabled) {
      setNumber(newNumber);
      onChange(newNumber);
    }
  }

  return (
    <>
      <div className="counter">
        <div
          className={`operator minus ${
            number === minimum || disabled ? 'disabled' : ''
          }`}
          onClick={decrease}
        >
          -
        </div>
        <div className="number">{number}</div>
        <div
          className={`operator plus ${
            number === maximum || disabled ? 'disabled' : ''
          }`}
          onClick={increase}
        >
          +
        </div>
      </div>
      <style jsx>{`
        .counter {
          display: flex;
          font-weight: 500;
          align-items: center;
          border-radius: 100px;
          border: 1.5px solid #dfe1e6;
          background: #fff;
        }
        .operator {
          width: 40px;
          text-align: center;
          border-radius: 100px;
          align-items: center;
          display: flex;
          justify-content: center;
          cursor: pointer;
          font-size: 25px;
          font-weight: 500;
          color:var(--grey-dark);
          line-height: 27px;
        }
        .operator:hover {
          border: none;
          transition: 0.2s ease;
          color: var(--input-border);
        }
        .operator.minus,
        .operator.plus {
          height: 40px;
        }
        .number {
          padding: 0em;
          min-width: 2em;
          text-align: center;
          border-radius: 100px;
          color:var(--grey-dark);
        }
        .disabled {
          opacity: 0.5;
          cursor: default;
        }
      `}</style>
    </>
  );
}

export default Counter;
